var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"item-chip"},[_c('div',{staticClass:"item-chip-icon"},[_vm._t("icon")],2),_c('div',{staticClass:"item-chip-text"},[_vm._t("text")],2),(_vm.removable)?_c('div',[_c('FilledClose',{staticClass:"close-button",on:{"click":function($event){return _vm.$emit('remove')}}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }